import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseStudyCategories, ApiResponseStudyCategoryProgresses } from '@/api/responses/studyCategories'

export namespace StudyCategoriesApi {
  /**
   * 通常授業サポート教材一覧取得
   *
   * @param gradeCode 学年コード
   * @param subjectCode 教科コード
   * @returns 教材一覧
   */
  export async function getGenerals(gradeCode: string, subjectCode: string): Promise<ApiResponseStudyCategories> {
    const params = {
      gradeCode: gradeCode,
      subjectCode: subjectCode,
    }
    return await ApiBase.get('/studyCategories/general', params)
  }

  /**
   * 講習会トレーニング教材一覧取得
   *
   * @param gradeCode 学年コード
   * @param subjectCode 教科コード
   * @returns 教材一覧
   */
  export async function getSeminar(gradeCode: string, subjectCode: string): Promise<ApiResponseStudyCategories> {
    const params = {
      gradeCode: gradeCode,
      subjectCode: subjectCode,
    }
    return await ApiBase.get('/studyCategories/seminar', params)
  }

  /**
   * 進捗状況付き通常授業サポート教材一覧取得
   *
   * @param gradeCode 学年コード
   * @param subjectCode 教科コード
   * @returns 進捗状況付き教材一覧
   */
  export async function getGeneralProgresses(
    gradeCode: string,
    subjectCode: string
  ): Promise<ApiResponseStudyCategoryProgresses> {
    const params = {
      gradeCode: gradeCode,
      subjectCode: subjectCode,
    }
    return await ApiBase.get('studyCategories/general/progress', params)
  }
}
